__turbopack_context__.v({
  "active": "lTVMvW_active",
  "container": "lTVMvW_container",
  "icon": "lTVMvW_icon",
  "playbackRateItem": "lTVMvW_playbackRateItem",
  "playbackRateItemText": "lTVMvW_playbackRateItemText",
  "playbackRatePopper": "lTVMvW_playbackRatePopper",
  "popper": "lTVMvW_popper",
});
